<evi-vertical-menu>
  <evi-vertical-menu-item
    label="System Info"
    (tgclick)="openSystemInfoModal()"
  ></evi-vertical-menu-item>

  <evi-vertical-menu-item
    label="Release Notes"
    (tgclick)="openReleaseNotesModal()"
  ></evi-vertical-menu-item>

  @if (licenseType === 'PC') {
    <evi-vertical-menu-item
      label="License"
      (tgclick)="openLicenseModal()"
    ></evi-vertical-menu-item>
  }
</evi-vertical-menu>
